/* Centauri C07 - Swiper feature tabs with scroll enhancement.
   Source tabpanels stay in Liquid for Theme Editor support; JS builds
   synchronized title/media Swipers and drives them from scroll. */
(function () {
  'use strict';

  var VERSION = '2026-08-25-c07-mobile-scroll-story';
  var ROOT_SELECTOR = '[data-centauri-tabs]';
  var PANEL_SELECTOR = '[data-centauri-tab-panel]';

  if (window.CentauriC07FeatureTabs && window.CentauriC07FeatureTabs.version === VERSION) {
    window.CentauriC07FeatureTabs.init();
    return;
  }

  var vendorStore = window.CentauriVendorPromises = window.CentauriVendorPromises || { scripts: {}, styles: {} };
  vendorStore.scripts = vendorStore.scripts || {};
  vendorStore.styles = vendorStore.styles || {};

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function automaticMediaAllowed() {
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!connection) return true;
    if (connection.saveData) return false;
    var effectiveType = String(connection.effectiveType || '').toLowerCase();
    return effectiveType !== 'slow-2g' && effectiveType !== '2g';
  }

  function matches(node, selector) {
    if (!node || node.nodeType !== 1) return false;
    var fn = node.matches || node.msMatchesSelector || node.webkitMatchesSelector;
    return fn ? fn.call(node, selector) : false;
  }

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function toBool(value, fallback) {
    if (value === undefined || value === null || value === '') return fallback;
    if (value === false || value === 'false' || value === '0' || value === 'no') return false;
    return true;
  }

  function clamp(value, min, max) {
    value = Number(value);
    if (!Number.isFinite(value)) return min;
    if (value < min) return min;
    if (value > max) return max;
    return value;
  }

  function clampIndex(index, count) {
    index = parseInt(index, 10);
    if (!Number.isFinite(index)) index = 0;
    if (count < 1) return 0;
    return clamp(index, 0, count - 1);
  }

  function indexToProgress(index, count) {
    if (count <= 1) return 0;
    return clampIndex(index, count) / (count - 1);
  }

  function progressToIndex(progress, count) {
    if (count <= 1) return 0;
    progress = clamp(progress, 0, 1);
    return clampIndex(Math.floor(progress * count), count);
  }

  function progressState(progress, count) {
    progress = clamp(progress, 0, 1);
    if (count <= 1) {
      return { progress: progress, position: 0, from: 0, to: 0, localProgress: 0, index: 0 };
    }

    var position = progress * count;
    var index = clampIndex(Math.floor(progress * count), count);
    var from = index;
    var to = clampIndex(index + 1, count);
    var localProgress = clamp(position - index, 0, 1);
    return {
      progress: progress,
      position: position,
      from: from,
      to: to,
      localProgress: localProgress,
      index: index
    };
  }

  function findRootNodes(scope) {
    var target = scope && scope.querySelectorAll ? scope : document;
    var roots = [];
    if (matches(scope, ROOT_SELECTOR)) roots.push(scope);
    return roots.concat(toArray(target.querySelectorAll(ROOT_SELECTOR)));
  }

  function normalizeUrl(url) {
    var anchor = document.createElement('a');
    anchor.href = url || '';
    return anchor.href;
  }

  function loadScriptOnce(url, globalReady) {
    if (globalReady && globalReady()) return Promise.resolve();
    if (!url) return Promise.resolve();

    var normalized = normalizeUrl(url);
    if (vendorStore.scripts[normalized]) return vendorStore.scripts[normalized];

    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i++) {
      if (scripts[i].src === normalized) {
        (function (existing) {
          vendorStore.scripts[normalized] = new Promise(function (resolve, reject) {
            if (globalReady && globalReady()) {
              resolve();
              return;
            }
            if (existing.readyState === 'complete' || existing.getAttribute('data-centauri-vendor-ready') === 'true') {
              resolve();
              return;
            }
            existing.addEventListener('load', function () {
              existing.setAttribute('data-centauri-vendor-ready', 'true');
              resolve();
            }, { once: true });
            existing.addEventListener('error', function () {
              reject(new Error('Unable to load C07 script: ' + normalized));
            }, { once: true });
          });
        })(scripts[i]);
        return vendorStore.scripts[normalized];
      }
    }

    vendorStore.scripts[normalized] = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = normalized;
      script.async = false;
      script.setAttribute('data-centauri-c07-vendor', 'true');
      script.onload = function () {
        script.setAttribute('data-centauri-vendor-ready', 'true');
        resolve();
      };
      script.onerror = function () {
        reject(new Error('Unable to load C07 script: ' + normalized));
      };
      document.head.appendChild(script);
    });

    return vendorStore.scripts[normalized];
  }

  function loadStyleOnce(url) {
    if (!url) return Promise.resolve();

    var normalized = normalizeUrl(url);
    if (vendorStore.styles[normalized]) return vendorStore.styles[normalized];

    var links = document.querySelectorAll('link[rel="stylesheet"]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].href === normalized) {
        vendorStore.styles[normalized] = Promise.resolve();
        return vendorStore.styles[normalized];
      }
    }

    vendorStore.styles[normalized] = new Promise(function (resolve, reject) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = normalized;
      link.setAttribute('data-centauri-c07-vendor', 'true');
      link.onload = function () { resolve(); };
      link.onerror = function () {
        reject(new Error('Unable to load C07 stylesheet: ' + normalized));
      };
      document.head.appendChild(link);
    });

    return vendorStore.styles[normalized];
  }

  function loadScrollVendors(root) {
    return loadScriptOnce(root.getAttribute('data-gsap-js'), function () { return !!window.gsap; })
      .then(function () {
        return loadScriptOnce(root.getAttribute('data-scrolltrigger-js'), function () { return !!window.ScrollTrigger; });
      });
  }

  function loadSwiperVendors(root) {
    return loadStyleOnce(root.getAttribute('data-swiper-css'))
      .then(function () {
        return loadScriptOnce(root.getAttribute('data-swiper-js'), function () { return !!window.Swiper; });
      });
  }

  function extractTitle(panel, fallback) {
    var heading = panel.querySelector('.centauri-c07__custom h1, .centauri-c07__custom h2, .centauri-c07__panel-title, h1, h2, h3');
    var text = heading ? heading.textContent.replace(/\s+/g, ' ').trim() : '';
    return text || fallback || 'Feature';
  }

  function panelId(panel, index) {
    if (panel.id) return panel.id;
    var id = 'centauri-c07-panel-' + index + '-' + Math.random().toString(36).slice(2, 8);
    panel.id = id;
    return id;
  }

  function centerActiveTab(state) {
    var strip = state.strip;
    var tab = state.tabs[state.activeIndex];
    if (!strip || !tab || strip.scrollWidth - strip.clientWidth <= 1) return;

    var stripRect = strip.getBoundingClientRect();
    var tabRect = tab.getBoundingClientRect();
    var delta = (tabRect.left - stripRect.left) - (stripRect.width - tabRect.width) / 2;
    if (typeof strip.scrollTo === 'function') {
      strip.scrollTo({ left: strip.scrollLeft + delta, behavior: reduceMotion() ? 'auto' : 'smooth' });
    } else {
      strip.scrollLeft += delta;
    }
  }

  function rootInViewport(state) {
    if (!state || !state.root || !state.root.getBoundingClientRect) return false;
    var rect = state.root.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight || 1;
    return rect.bottom > 0 && rect.top < vh;
  }

  function videoDisplayed(video) {
    if (!video || !video.getClientRects || !video.getClientRects().length) return false;
    if (!window.getComputedStyle) return true;
    var style = window.getComputedStyle(video);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function prepareVideoPlayback(video) {
    if (!video) return;
    video.autoplay = true;
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('autoplay', '');
    video.setAttribute('muted', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');
    if (video.getAttribute('preload') === 'none') video.setAttribute('preload', 'metadata');
  }

  function revealVideoSources(video) {
    if (!video) return false;
    var changed = false;
    var sources = video.querySelectorAll ? video.querySelectorAll('source[data-src]') : [];
    for (var i = 0; i < sources.length; i++) {
      var source = sources[i];
      var src = source.getAttribute('data-src');
      if (src && !source.getAttribute('src')) {
        source.setAttribute('src', src);
        source.removeAttribute('data-src');
        changed = true;
      }
    }
    if (changed && typeof video.load === 'function') {
      try { video.load(); } catch (e) {}
    }
    return changed;
  }

  function setVideoBlocked(video, blocked) {
    if (!video) return;
    var media = video.closest ? video.closest('.centauri-c07__media') : null;
    if (blocked) {
      video.setAttribute('data-centauri-video-blocked', 'true');
      if (media) media.setAttribute('data-centauri-video-blocked', 'true');
    } else {
      video.removeAttribute('data-centauri-video-blocked');
      if (media) media.removeAttribute('data-centauri-video-blocked');
    }
  }

  function pauseVideos(scope) {
    var videos = scope ? scope.querySelectorAll('video') : [];
    for (var i = 0; i < videos.length; i++) {
      try {
        prepareVideoPlayback(videos[i]);
        setVideoBlocked(videos[i], false);
        var media = videos[i].closest ? videos[i].closest('.centauri-c07__media') : null;
        if (media) media.classList.remove('is-mobile-video-playing');
        if (typeof videos[i].pause === 'function') videos[i].pause();
      } catch (e) {}
    }
  }

  function playVideos(scope, allow) {
    var videos = scope ? scope.querySelectorAll('video') : [];
    for (var i = 0; i < videos.length; i++) {
      var video = videos[i];
      try {
        prepareVideoPlayback(video);
        if (!allow || !videoDisplayed(video)) {
          if (typeof video.pause === 'function') video.pause();
          continue;
        }
        revealVideoSources(video);
        if (typeof video.play === 'function') {
          (function (targetVideo) {
            setVideoBlocked(targetVideo, false);
            var promise = targetVideo.play();
            if (promise && typeof promise.then === 'function') {
              promise
                .then(function () { setVideoBlocked(targetVideo, false); })
                .catch(function () { setVideoBlocked(targetVideo, true); });
            }
          })(video);
        }
      } catch (e) {}
    }
  }

  function warmMedia(scope) {
    if (!scope) return;

    var videos = scope.querySelectorAll('video');
    for (var v = 0; v < videos.length; v++) {
      try {
        revealVideoSources(videos[v]);
        if (videos[v].getAttribute('preload') === 'none') videos[v].setAttribute('preload', 'metadata');
        if (videos[v].readyState === 0 && typeof videos[v].load === 'function') videos[v].load();
      } catch (e) {}
    }

    var images = scope.querySelectorAll('img');
    for (var i = 0; i < images.length; i++) {
      try {
        if (images[i].complete && typeof images[i].decode === 'function') {
          images[i].decode().catch(function () {});
        }
      } catch (err) {}
    }
  }

  function warmAdjacentMedia(state, index) {
    if (!state || state.destroyed || !state.activeInViewport || !automaticMediaAllowed()) return;
    warmMedia(state.mediaSlides[index]);
    warmMedia(state.mediaSlides[clampIndex(index + 1, state.count)]);
  }

  function updateMediaPlayback(state) {
    if (!state || state.destroyed) return;
    // C07 is an intentional ambient-motion module: its active MP4 must play on
    // every device while the component and page are visible. Muted + playsinline
    // are enforced in prepareVideoPlayback so browser autoplay policy is satisfied.
    var allowPlay = state.activeInViewport && !document.hidden;
    if (!allowPlay) {
      pauseVideos(state.root);
      return;
    }

    for (var p = 0; p < state.panels.length; p++) {
      if (p === state.activeIndex) playVideos(state.panels[p], true);
    }
    for (var s = 0; s < state.mediaSlides.length; s++) {
      if (s === state.activeIndex) playVideos(state.mediaSlides[s], true);
    }
  }

  function scheduleMediaPlayback(state, reason) {
    if (!state || state.destroyed) return;
    if (reason) state.root.setAttribute('data-centauri-media-sync', reason);

    window.cancelAnimationFrame(state.playbackFrame);
    window.clearTimeout(state.playbackRetryTimer);
    window.clearTimeout(state.playbackTransitionTimer);

    state.playbackFrame = window.requestAnimationFrame(function () {
      if (!state || state.destroyed) return;
      syncCarouselIndex(state, true);
      if (!mobileMode()) updateViewportState(state);
      updateMediaPlayback(state);
      state.playbackRetryTimer = window.setTimeout(function () {
        if (!state || state.destroyed) return;
        syncCarouselIndex(state, true);
        if (!mobileMode()) updateViewportState(state);
        updateMediaPlayback(state);
      }, 250);
      state.playbackTransitionTimer = window.setTimeout(function () {
        if (!state || state.destroyed) return;
        syncCarouselIndex(state, true);
        if (!mobileMode()) updateViewportState(state);
        updateMediaPlayback(state);
      }, mobileMode() ? 760 : 900);
    });
  }

  function updateViewportState(state) {
    if (!state || state.destroyed) return;
    setViewportState(state, rootInViewport(state));
  }

  function setViewportState(state, active) {
    if (!state || state.destroyed) return;
    if (state.activeInViewport !== active) {
      state.activeInViewport = active;
      if (active) warmAdjacentMedia(state, state.activeIndex);
      updateMediaPlayback(state);
    }
  }

  function setupViewportObserver(state) {
    if (!state || state.destroyed || state.viewportObserver || !('IntersectionObserver' in window)) return;
    state.viewportObserver = new IntersectionObserver(function (records) {
      var active = false;
      for (var i = 0; i < records.length; i++) {
        if (records[i].isIntersecting) {
          active = true;
          break;
        }
      }
      setViewportState(state, active);
    });
    state.viewportObserver.observe(state.root);
  }

  function syncViewportTracking(state) {
    if (!state || state.destroyed) return;

    if (mobileMode()) {
      if (state.scrollMediaHandler) {
        window.removeEventListener('scroll', state.scrollMediaHandler);
        state.scrollMediaHandler = null;
      }
      setupViewportObserver(state);
      if (!state.viewportObserver) {
        setViewportState(state, false);
        updateMediaPlayback(state);
        return;
      }
      return;
    }

    if (state.viewportObserver && state.viewportObserver.disconnect) state.viewportObserver.disconnect();
    state.viewportObserver = null;
    if (!state.scrollMediaHandler) {
      state.scrollMediaHandler = function () {
        updateViewportState(state);
        scheduleMediaPlayback(state, 'scroll');
      };
      window.addEventListener('scroll', state.scrollMediaHandler, { passive: true });
    }
    updateViewportState(state);
  }

  function setMobileTabbarPinned(state, pinned) {
    if (!state || !state.root || !state.section) return;
    state.root.classList.toggle('is-mobile-tabbar-fixed', !!pinned);
    state.section.classList.toggle('is-mobile-tabbar-fixed', !!pinned);
  }

  function updateMobileTabbarPin(state) {
    if (!state || state.destroyed || !state.section || !state.strip || !mobileMode()) {
      setMobileTabbarPinned(state, false);
      return;
    }

    var rect = state.section.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
    var barHeight = state.strip.getBoundingClientRect().height || 0;
    var pinned = rect.top <= viewportHeight - barHeight && rect.bottom > viewportHeight;
    setMobileTabbarPinned(state, pinned);
  }

  function scheduleMobileTabbarPin(state) {
    if (!state || state.destroyed || state.mobileTabbarFrame) return;
    state.mobileTabbarFrame = window.requestAnimationFrame(function () {
      state.mobileTabbarFrame = 0;
      updateMobileTabbarPin(state);
    });
  }

  function setSlideState(state, index) {
    for (var i = 0; i < state.titleSlides.length; i++) {
      state.titleSlides[i].classList.toggle('is-active', i === index);
      state.titleSlides[i].setAttribute('aria-hidden', i === index ? 'false' : 'true');
    }
    for (var s = 0; s < state.mediaSlides.length; s++) {
      state.mediaSlides[s].classList.toggle('is-active', s === index);
      state.mediaSlides[s].setAttribute('aria-hidden', s === index ? 'false' : 'true');
    }
  }

  function goToSwiper(swiper, index, speed) {
    if (!swiper || typeof swiper.slideTo !== 'function') return false;
    if (typeof speed === 'number') swiper.slideTo(index, speed);
    else swiper.slideTo(index);
    return true;
  }

  function syncCarouselIndex(state, immediate) {
    if (!state || !state.carouselReady || state.syncingCarousel) return;
    var index = clampIndex(state.activeIndex, state.count);
    var speed = immediate ? 0 : undefined;
    var changed = false;

    if (state.titleSwiper && state.titleSwiper.activeIndex !== index) {
      changed = goToSwiper(state.titleSwiper, index, speed) || changed;
    }
    if (state.mediaSwiper && state.mediaSwiper.activeIndex !== index) {
      changed = goToSwiper(state.mediaSwiper, index, speed) || changed;
    }

    if (changed) {
      state.syncingCarousel = true;
      window.setTimeout(function () {
        if (state) state.syncingCarousel = false;
      }, 0);
    }
  }

  function setTransitionDirection(state, index) {
    if (!state || state.count < 1) return 'forward';
    var direction = index < state.activeIndex ? 'backward' : 'forward';
    state.transitionDirection = direction;
    state.root.setAttribute('data-c07-direction', direction);
    if (state.section) state.section.setAttribute('data-c07-direction', direction);
    if (state.motionShell) state.motionShell.setAttribute('data-c07-direction', direction);
    return direction;
  }

  function writeMotionProgress(state, detail) {
    if (!state || !state.motionShell || !detail) return;
    var previous = typeof state.lastScrollProgress === 'number' ? state.lastScrollProgress : detail.progress;
    var direction = detail.progress > previous ? 1 : detail.progress < previous ? -1 : (state.motionDirection || 0);
    var localPulse = Math.sin(detail.localProgress * Math.PI);
    var shellShift = direction && !reduceMotion() ? localPulse * direction * -6 : 0;

    state.lastScrollProgress = detail.progress;
    state.motionDirection = direction;
    state.motionShell.style.setProperty('--c07-scroll-progress', detail.progress.toFixed(4));
    state.motionShell.style.setProperty('--c07-local-progress', detail.localProgress.toFixed(4));
    state.motionShell.style.setProperty('--c07-motion-direction', String(direction));
    state.motionShell.style.setProperty('--c07-shell-shift', shellShift.toFixed(2) + 'px');
    state.motionShell.classList.toggle('is-motion-forward', direction > 0);
    state.motionShell.classList.toggle('is-motion-backward', direction < 0);
  }

  function setCarouselIndex(state, index) {
    if (!state.carouselReady || state.syncingCarousel) return;
    state.syncingCarousel = true;
    goToSwiper(state.titleSwiper, index);
    goToSwiper(state.mediaSwiper, index);
    window.setTimeout(function () {
      if (state) state.syncingCarousel = false;
    }, 0);
  }

  function activate(state, index, focusTab, immediate, fromCarousel) {
    if (!state || state.destroyed || state.count < 1) return;
    index = clampIndex(index, state.count);
    var coverflowActive = coverflowEligible(state) && state.root.classList.contains('is-coverflow-enhanced') && !state.root.classList.contains('is-simple-tabs');
    setTransitionDirection(state, index);

    for (var i = 0; i < state.count; i++) {
      var isActive = i === index;
      var tab = state.tabs[i];
      var panel = state.panels[i];

      if (tab) {
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      }

      if (panel) {
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        if (coverflowActive) {
          panel.removeAttribute('hidden');
        } else if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      }
    }

    state.activeIndex = index;
    state.root.setAttribute('data-centauri-active-index', String(index));
    if (state.section) state.section.setAttribute('data-centauri-active-index', String(index));
    if (state.motionShell) state.motionShell.setAttribute('data-centauri-active-index', String(index));
    setSlideState(state, index);
    if (!fromCarousel) setCarouselIndex(state, index);
    warmAdjacentMedia(state, index);
    updateMediaPlayback(state);
    scheduleMediaPlayback(state, 'activate');
    centerActiveTab(state);
    if (focusTab && state.tabs[index]) state.tabs[index].focus({ preventScroll: !!immediate });
  }

  function scrollDriveEligible(state) {
    // C07 is intentionally scroll-driven by default. reduceMotion() still governs
    // smooth-scroll behavior used elsewhere. The mobile layout has its own
    // 400vh runway and sticky-stage styles, so it follows the desktop story:
    // pin, reveal every panel in sequence, then release normal page scrolling.
    return state.enableScrollDrive && state.count > 1;
  }

  function mobileMode() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  function coverflowEligible(state) {
    return state.enableCoverflow;
  }

  function dynamicTrackVh(state) {
    var transitions = Math.max((state && state.count || 1) - 1, 1);
    var base = 100;
    // The production C07 composition has three panels. This pacing gives that
    // composition a 500vh desktop / 400vh mobile runway, matching the supplied
    // OnePlus sticky-story reference while continuing to scale for extra panels.
    var perTransition = mobileMode() ? 150 : 200;
    return Math.round(base + (transitions * perTransition));
  }

  function applyDynamicTrack(state) {
    if (!state || !state.section) return;
    state.section.style.setProperty('--centauri-c07-effective-track-vh', String(dynamicTrackVh(state)));
  }

  function resolveLengthPx(owner, value) {
    if (!owner || !value || value === '0' || value === '0px') return 0;
    var probe = document.createElement('div');
    probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;width:0;height:' + value + ';';
    owner.appendChild(probe);
    var px = probe.getBoundingClientRect().height;
    owner.removeChild(probe);
    return Number.isFinite(px) ? px : 0;
  }

  function stickyOffsetPx(state) {
    if (!state.section || !window.getComputedStyle) return 0;
    var value = window.getComputedStyle(state.section).getPropertyValue('--centauri-c07-sticky-offset').trim();
    return resolveLengthPx(state.section, value);
  }

  function updateNativeProgress(state, allowActivate) {
    if (!state || !state.scroller) return;
    updateViewportState(state);
    var rect = state.scroller.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight || 1;
    var offset = stickyOffsetPx(state);
    var total = Math.max(1, rect.height - vh + offset);
    var progress = clamp((offset - rect.top) / total, 0, 1);
    updateScrollProgress(state, progress, allowActivate);
  }

  function updateScrollProgress(state, progress, allowActivate) {
    if (!state || state.destroyed) return;
    var detail = progressState(progress, state.count);
    var next = detail.index;

    if (next === state.scrollIndex && (!allowActivate || next === state.activeIndex)) {
      return;
    }

    state.scrollIndex = next;
    state.root.setAttribute('data-centauri-scroll-progress', detail.progress.toFixed(4));
    state.root.setAttribute('data-centauri-scroll-position', detail.position.toFixed(4));
    state.root.setAttribute('data-centauri-scroll-local-progress', detail.localProgress.toFixed(4));
    writeMotionProgress(state, detail);
    if (allowActivate && next !== state.activeIndex) activate(state, next, false, false);
  }

  function killNativeFallback(state) {
    if (!state.fallbackHandler) return;
    window.removeEventListener('scroll', state.fallbackHandler);
    window.removeEventListener('resize', state.fallbackHandler);
    state.fallbackHandler = null;
    if (state.fallbackFrame) window.cancelAnimationFrame(state.fallbackFrame);
    state.fallbackFrame = 0;
  }

  function setupNativeFallback(state) {
    killNativeFallback(state);
    if (!scrollDriveEligible(state)) return;
    applyDynamicTrack(state);
    state.root.classList.remove('is-scroll-drive-disabled', 'is-scroll-drive-ready');
    state.root.classList.add('is-scroll-drive-fallback');

    var ticking = false;
    state.fallbackHandler = function () {
      if (ticking) return;
      ticking = true;
      state.fallbackFrame = window.requestAnimationFrame(function () {
        ticking = false;
        state.fallbackFrame = 0;
        updateNativeProgress(state, !state.manualLock);
      });
    };
    window.addEventListener('scroll', state.fallbackHandler, { passive: true });
    window.addEventListener('resize', state.fallbackHandler, { passive: true });
    updateNativeProgress(state, true);
  }

  function killScrollDrive(state) {
    if (state.scrollTrigger && state.scrollTrigger.kill) state.scrollTrigger.kill();
    state.scrollTrigger = null;
    killNativeFallback(state);
    state.root.classList.remove('is-scroll-drive-ready', 'is-scroll-drive-fallback');
    state.root.removeAttribute('data-centauri-scroll-ready');
  }

  function markScrollDisabled(state) {
    killScrollDrive(state);
    state.root.classList.add('is-scroll-drive-disabled');
    if (state.section) state.section.classList.add('is-scroll-drive-disabled');
    state.root.setAttribute('data-centauri-scroll-progress', '0.0000');
  }

  function syncScrollDriveMode(state) {
    if (!state || state.destroyed) return;
    if (!scrollDriveEligible(state)) {
      markScrollDisabled(state);
      if (state.vendorObserver && state.vendorObserver.disconnect) state.vendorObserver.disconnect();
      state.vendorObserver = null;
      state.vendorRequested = false;
    }
  }

  function configureScrollDrive(state) {
    if (!state || state.destroyed) return;
    killScrollDrive(state);
    applyDynamicTrack(state);

    if (!scrollDriveEligible(state)) {
      markScrollDisabled(state);
      return;
    }

    if (!window.gsap || !window.ScrollTrigger || !state.scroller) {
      setupNativeFallback(state);
      return;
    }

    window.gsap.registerPlugin(window.ScrollTrigger);
    state.root.classList.remove('is-scroll-drive-disabled', 'is-scroll-drive-fallback');
    if (state.section) state.section.classList.remove('is-scroll-drive-disabled');

    state.scrollTrigger = window.ScrollTrigger.create({
      trigger: state.scroller,
      start: function () { return 'top ' + stickyOffsetPx(state) + 'px'; },
      end: 'bottom bottom',
      invalidateOnRefresh: true,
      onUpdate: function (self) {
        if (state.destroyed) return;
        updateViewportState(state);
        updateScrollProgress(state, self.progress, !state.manualLock);
      }
    });

    state.root.classList.add('is-scroll-drive-ready');
    state.root.setAttribute('data-centauri-scroll-ready', 'true');
    if (window.ScrollTrigger.refresh) window.ScrollTrigger.refresh();
    activate(state, progressToIndex(state.scrollTrigger.progress || 0, state.count), false, true);
  }

  function loadVendorDriveWhenNear(state) {
    if (!state || state.destroyed || state.vendorRequested || state.vendorObserver) return;

    function request() {
      if (!state || state.destroyed || state.vendorRequested) return;
      state.vendorRequested = true;
      if (state.vendorObserver && state.vendorObserver.disconnect) state.vendorObserver.disconnect();
      state.vendorObserver = null;
      loadScrollVendors(state.root)
        .then(function () { configureScrollDrive(state); })
        .catch(function () {
          if (!state.destroyed) setupNativeFallback(state);
        });
    }

    if (!('IntersectionObserver' in window)) {
      request();
      return;
    }

    state.vendorObserver = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          request();
          break;
        }
      }
    }, { rootMargin: '800px 0px' });
    state.vendorObserver.observe(state.root);
  }

  function ensureScrollDrive(state) {
    if (!state || state.destroyed) return;
    if (!scrollDriveEligible(state)) {
      markScrollDisabled(state);
      return;
    }
    if (!window.gsap || !window.ScrollTrigger) {
      setupNativeFallback(state);
      loadVendorDriveWhenNear(state);
      return;
    }
    configureScrollDrive(state);
  }

  function scrollToProgress(state, progress) {
    progress = clamp(progress, 0, 1);
    if (state.scrollTrigger && state.scrollTrigger.start !== undefined && state.scrollTrigger.end !== undefined) {
      if (state.scrollTrigger.refresh) state.scrollTrigger.refresh();
      var start = Number(state.scrollTrigger.start) || 0;
      var end = Number(state.scrollTrigger.end) || start;
      var target = Math.round(start + ((end - start) * progress));
      try {
        window.scrollTo({ top: target, behavior: reduceMotion() ? 'auto' : 'smooth' });
      } catch (e) {
        window.scrollTo(0, target);
      }
      return true;
    }

    if (state.fallbackHandler && state.scroller) {
      var rect = state.scroller.getBoundingClientRect();
      var pageTop = window.pageYOffset + rect.top;
      var offset = stickyOffsetPx(state);
      var span = Math.max(1, state.scroller.offsetHeight - (window.innerHeight || 1) + offset);
      var fallbackTarget = Math.round(pageTop - offset + (span * progress));
      try {
        window.scrollTo({ top: fallbackTarget, behavior: reduceMotion() ? 'auto' : 'smooth' });
      } catch (err) {
        window.scrollTo(0, fallbackTarget);
      }
      return true;
    }

    return false;
  }

  function unlockManualScroll(state) {
    window.clearTimeout(state.unlockTimer);
    state.unlockTimer = window.setTimeout(function () {
      if (!state || state.destroyed) return;
      state.manualLock = false;
      if (state.scrollTrigger) {
        activate(state, progressToIndex(state.scrollTrigger.progress || 0, state.count), false, false);
      } else if (state.fallbackHandler) {
        updateNativeProgress(state, true);
      }
    }, 950);
  }

  function goTo(state, index, focusTab) {
    if (!state || state.destroyed) return;
    index = clampIndex(index, state.count);
    activate(state, index, focusTab, false);

    if (scrollDriveEligible(state) && (state.scrollTrigger || state.fallbackHandler)) {
      state.manualLock = true;
      scrollToProgress(state, indexToProgress(index, state.count));
      unlockManualScroll(state);
    }
  }

  function onKeydown(state, event) {
    var key = event.key;
    var index = state.activeIndex;

    if (key === 'ArrowRight' || key === 'ArrowDown') {
      event.preventDefault();
      goTo(state, index + 1, true);
    } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
      event.preventDefault();
      goTo(state, index - 1, true);
    } else if (key === 'Home') {
      event.preventDefault();
      goTo(state, 0, true);
    } else if (key === 'End') {
      event.preventDefault();
      goTo(state, state.count - 1, true);
    } else if (key === 'Enter' || key === ' ' || key === 'Spacebar') {
      event.preventDefault();
      goTo(state, index, false);
    }
  }

  function buildTabs(state) {
    state.strip.innerHTML = '';
    state.tabs = [];

    for (var i = 0; i < state.panels.length; i++) {
      var panel = state.panels[i];
      var pid = panelId(panel, i);
      var label = panel.getAttribute('data-tab-label') || ('Tab ' + (i + 1));
      var tabId = panel.getAttribute('data-tab-id') || (pid + '-tab');
      var tab = document.createElement('button');

      tab.type = 'button';
      tab.className = 'c07__tab';
      tab.id = tabId;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', pid);
      tab.setAttribute('aria-selected', 'false');
      tab.setAttribute('tabindex', '-1');
      tab.textContent = label;
      panel.setAttribute('aria-labelledby', tabId);

      (function (targetIndex) {
        var clickHandler = function () { goTo(state, targetIndex, false); };
        tab.addEventListener('click', clickHandler);
        state.cleanups.push(function () { tab.removeEventListener('click', clickHandler); });
      })(i);

      state.strip.appendChild(tab);
      state.tabs.push(tab);
    }

    state.strip.style.setProperty('--c07-tab-count', String(state.tabs.length));
    if (state.tabs.length < 2) state.strip.hidden = true;

    var keyHandler = function (event) { onKeydown(state, event); };
    state.strip.addEventListener('keydown', keyHandler);
    state.cleanups.push(function () {
      state.strip.removeEventListener('keydown', keyHandler);
    });
  }

  function createCarouselSlide(className) {
    var slide = document.createElement('div');
    slide.className = className + ' swiper-slide';
    return slide;
  }

  function buildCarouselDom(state) {
    if (!state.titleWrapper || !state.mediaWrapper || !state.titleCarousel || !state.mediaCarousel) return false;

    state.titleWrapper.innerHTML = '';
    state.mediaWrapper.innerHTML = '';

    for (var i = 0; i < state.panels.length; i++) {
      var panel = state.panels[i];
      var label = panel.getAttribute('data-tab-label') || ('Tab ' + (i + 1));
      var titleSlide = createCarouselSlide('c07__title-slide');
      var titleText = document.createElement('div');
      var mediaSlide = createCarouselSlide('c07__media-slide');
      var media = panel.querySelector('.centauri-c07__media');

      titleText.className = 'c07__title-text';
      titleText.textContent = extractTitle(panel, label);
      titleSlide.appendChild(titleText);

      if (media) {
        var placeholder = document.createComment('centauri-c07-media-placeholder');
        media.parentNode.insertBefore(placeholder, media);
        mediaSlide.appendChild(media);
        state.mediaPlacements.push({
          panel: panel,
          media: media,
          placeholder: placeholder
        });
      } else {
        var empty = document.createElement('div');
        empty.className = 'centauri-c07__media centauri-c07__media--empty';
        empty.setAttribute('aria-hidden', 'true');
        mediaSlide.appendChild(empty);
      }

      state.titleWrapper.appendChild(titleSlide);
      state.mediaWrapper.appendChild(mediaSlide);
      state.titleSlides.push(titleSlide);
      state.mediaSlides.push(mediaSlide);
    }

    state.root.classList.add('is-coverflow-enhanced', 'is-coverflow-pending');
    if (state.section) state.section.classList.add('is-coverflow-enhanced', 'is-coverflow-pending');
    return true;
  }

  function restoreCarouselDom(state) {
    destroySwipers(state);

    for (var i = 0; i < state.mediaPlacements.length; i++) {
      var placement = state.mediaPlacements[i];
      if (placement.placeholder && placement.placeholder.parentNode && placement.media) {
        placement.placeholder.parentNode.insertBefore(placement.media, placement.placeholder);
        placement.placeholder.parentNode.removeChild(placement.placeholder);
      }
    }

    state.mediaPlacements = [];
    state.titleSlides = [];
    state.mediaSlides = [];
    if (state.titleWrapper) state.titleWrapper.innerHTML = '';
    if (state.mediaWrapper) state.mediaWrapper.innerHTML = '';
  }

  function bindSwiperEvents(state) {
    if (state.carouselEventsBound || !state.titleSwiper || !state.mediaSwiper) return;
    state.carouselEventsBound = true;

    function onSwiperChange(swiper) {
      if (state.destroyed || state.syncingCarousel) return;
      var index = clampIndex(swiper && swiper.activeIndex || 0, state.count);
      if (index !== state.activeIndex) activate(state, index, false, false, true);
      scheduleMediaPlayback(state, 'swiper-change');
    }

    state.titleSwiper.on('slideChange', function () { onSwiperChange(state.titleSwiper); });
    state.mediaSwiper.on('slideChange', function () { onSwiperChange(state.mediaSwiper); });
    state.titleSwiper.on('slideChangeTransitionEnd', function () { scheduleMediaPlayback(state, 'swiper-title-end'); });
    state.mediaSwiper.on('slideChangeTransitionEnd', function () { scheduleMediaPlayback(state, 'swiper-media-end'); });
    state.titleSwiper.on('transitionEnd', function () { scheduleMediaPlayback(state, 'swiper-title-transition'); });
    state.mediaSwiper.on('transitionEnd', function () { scheduleMediaPlayback(state, 'swiper-media-transition'); });
  }

  function swiperOptions(kind) {
    return {
      effect: 'creative',
      slidesPerView: 1,
      speed: mobileMode() ? 680 : 820,
      allowTouchMove: false,
      grabCursor: false,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      rewind: false,
      creativeEffect: {
        perspective: false,
        limitProgress: 1,
        shadowPerProgress: false,
        prev: {
          translate: ['-10%', 0, 0],
          opacity: 0.24,
          scale: 0.985,
          shadow: false
        },
        next: {
          translate: ['10%', 0, 0],
          opacity: 0.24,
          scale: 0.985,
          shadow: false
        }
      }
    };
  }

  function destroySwipers(state) {
    if (state.titleSwiper && typeof state.titleSwiper.destroy === 'function') {
      state.titleSwiper.destroy(true, true);
    }
    if (state.mediaSwiper && typeof state.mediaSwiper.destroy === 'function') {
      state.mediaSwiper.destroy(true, true);
    }
    state.titleSwiper = null;
    state.mediaSwiper = null;
    state.carouselEventsBound = false;
    state.carouselReady = false;
  }

  function initSwipers(state) {
    if (!coverflowEligible(state)) return false;
    if (!window.Swiper || !state.titleCarousel || !state.mediaCarousel) return false;
    destroySwipers(state);
    try {
      state.titleSwiper = new window.Swiper(state.titleCarousel, swiperOptions('title'));
      state.mediaSwiper = new window.Swiper(state.mediaCarousel, swiperOptions('media'));
    } catch (error) {
      destroySwipers(state);
      return false;
    }
    bindSwiperEvents(state);
    return true;
  }

  function markCarouselReady(state) {
    if (state.carouselReady || state.destroyed) return;
    if (!coverflowEligible(state)) {
      markSimpleTabs(state);
      return;
    }
    state.carouselReady = true;
    state.root.classList.remove('is-coverflow-pending', 'is-coverflow-fallback');
    state.root.classList.add('is-coverflow-ready');
    state.root.setAttribute('data-centauri-carousel-ready', 'true');
    if (state.section) {
      state.section.classList.remove('is-coverflow-pending', 'is-coverflow-fallback');
      state.section.classList.add('is-coverflow-ready');
    }
    activate(state, state.activeIndex, false, true);
    scheduleMediaPlayback(state, 'carousel-ready');
    scheduleRefresh(state);
  }

  function loadCarouselWhenNear(state) {
    if (!state || state.destroyed || !coverflowEligible(state) || state.carouselRequested || state.carouselObserver || state.waitingForCarousel) return;

    var didRequest = false;
    var cleanupEvents = function () {};

    function request() {
      if (!state || state.destroyed || !coverflowEligible(state) || didRequest || state.carouselRequested) return;
      didRequest = true;
      state.carouselRequested = true;
      if (state.carouselObserver && state.carouselObserver.disconnect) state.carouselObserver.disconnect();
      state.carouselObserver = null;
      cleanupEvents();
      state.carouselInteractionCleanup = null;
      ensureCarouselReady(state, true);
    }

    var interactionEvents = ['pointerdown', 'focusin', 'keydown', 'touchstart', 'wheel'];
    for (var i = 0; i < interactionEvents.length; i++) {
      state.root.addEventListener(interactionEvents[i], request, { passive: true });
    }
    cleanupEvents = function () {
      for (var j = 0; j < interactionEvents.length; j++) {
        state.root.removeEventListener(interactionEvents[j], request);
      }
    };
    state.carouselInteractionCleanup = cleanupEvents;

    if (!('IntersectionObserver' in window)) {
      request();
      return;
    }

    state.carouselObserver = new IntersectionObserver(function (entries) {
      for (var entryIndex = 0; entryIndex < entries.length; entryIndex++) {
        if (entries[entryIndex].isIntersecting) {
          request();
          break;
        }
      }
    }, { rootMargin: '1000px 0px' });
    state.carouselObserver.observe(state.root);
  }

  function ensureCarouselReady(state, immediate) {
    if (!state.enableCoverflow) return;
    if (!coverflowEligible(state)) {
      markSimpleTabs(state);
      return;
    }
    if (!state.titleCarousel || !state.mediaCarousel) {
      markCoverflowFallback(state);
      return;
    }

    if (state.waitingForCarousel) return;
    if (window.Swiper) {
      if (!initSwipers(state)) {
        markCoverflowFallback(state);
        return;
      }
      window.setTimeout(function () {
        if (!state.destroyed) markCarouselReady(state);
      }, 0);
      return;
    }

    if (!immediate) {
      loadCarouselWhenNear(state);
      return;
    }

    state.waitingForCarousel = true;
    loadSwiperVendors(state.root)
      .then(function () {
        state.waitingForCarousel = false;
        if (state.destroyed) return;
        if (!coverflowEligible(state)) {
          markSimpleTabs(state);
          return;
        }
        if (!initSwipers(state)) {
          markCoverflowFallback(state);
          return;
        }
        markCarouselReady(state);
      })
      .catch(function () {
        state.waitingForCarousel = false;
        if (!state.destroyed) {
          if (!coverflowEligible(state)) markSimpleTabs(state);
          else markCoverflowFallback(state);
        }
      });
  }

  function markCoverflowFallback(state) {
    markSimpleTabs(state);
    state.root.classList.add('is-coverflow-fallback');
    if (state.section) state.section.classList.add('is-coverflow-fallback');
  }

  function clearCarouselRequests(state) {
    if (state.carouselObserver && state.carouselObserver.disconnect) state.carouselObserver.disconnect();
    state.carouselObserver = null;
    if (state.carouselInteractionCleanup) state.carouselInteractionCleanup();
    state.carouselInteractionCleanup = null;
    state.carouselRequested = false;
    state.waitingForCarousel = false;
  }

  function markSimpleTabs(state) {
    clearCarouselRequests(state);
    restoreCarouselDom(state);
    state.carouselReady = false;
    state.root.classList.remove('is-coverflow-enhanced', 'is-coverflow-pending', 'is-coverflow-ready', 'is-coverflow-fallback');
    state.root.classList.add('is-simple-tabs');
    state.root.removeAttribute('data-centauri-carousel-ready');
    if (state.section) {
      state.section.classList.remove('is-coverflow-enhanced', 'is-coverflow-pending', 'is-coverflow-ready', 'is-coverflow-fallback');
      state.section.classList.add('is-simple-tabs');
    }
    activate(state, state.activeIndex, false, true);
  }

  function syncCarouselMode(state) {
    if (!state || state.destroyed) return;
    if (!coverflowEligible(state)) {
      markSimpleTabs(state);
      return;
    }
    state.root.classList.remove('is-simple-tabs', 'is-coverflow-fallback');
    if (state.section) state.section.classList.remove('is-simple-tabs', 'is-coverflow-fallback');
    if (state.mediaPlacements.length || state.titleSlides.length) {
      if (state.titleSwiper && state.mediaSwiper) return;
      ensureCarouselReady(state);
      return;
    }
    if (!buildCarouselDom(state)) {
      markCoverflowFallback(state);
      return;
    }
    ensureCarouselReady(state);
  }

  function scheduleRefresh(state) {
    window.clearTimeout(state.refreshTimer);
    state.refreshTimer = window.setTimeout(function () {
      if (!state.destroyed && window.ScrollTrigger && window.ScrollTrigger.refresh) {
        window.ScrollTrigger.refresh();
      } else if (!state.destroyed && state.fallbackHandler) {
        updateNativeProgress(state, true);
      }
    }, 80);
  }

  function setupAssetRefresh(state) {
    var nodes = state.root.querySelectorAll('img, video');
    for (var i = 0; i < nodes.length; i++) {
      (function (node) {
        var eventName = node.tagName && node.tagName.toLowerCase() === 'video' ? 'loadedmetadata' : 'load';
        var handler = function () {
          scheduleRefresh(state);
          if (node.tagName && node.tagName.toLowerCase() === 'video') {
            scheduleMediaPlayback(state, eventName);
          }
        };
        node.addEventListener(eventName, handler, { once: true });
        if (node.tagName && node.tagName.toLowerCase() === 'video') {
          var canPlayHandler = function () { scheduleMediaPlayback(state, 'canplay'); };
          node.addEventListener('canplay', canPlayHandler);
          state.cleanups.push(function () {
            node.removeEventListener('canplay', canPlayHandler);
          });
        }
        state.cleanups.push(function () {
          node.removeEventListener(eventName, handler);
        });
      })(nodes[i]);
    }
  }

  function setupReveal(state) {
    var groups = state.root.querySelectorAll('[data-hover-reveal]');
    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      if (group.dataset.revealReady === 'true') continue;
      var items = toArray(group.querySelectorAll('[data-reveal-item]'));
      if (!items.length) continue;

      if (items.length === 1) {
        items[0].classList.add('is-open');
        group.classList.add('is-single');
        group.dataset.revealReady = 'true';
        continue;
      }

      (function (rows) {
        function open(target) {
          for (var i = 0; i < rows.length; i++) {
            rows[i].classList.toggle('is-open', rows[i] === target);
          }
        }

        open(rows[0]);
        rows.forEach(function (item) {
          var trigger = item.querySelector('[data-reveal-trigger]') || item;
          var mouseHandler = function () { open(item); };
          var focusHandler = function () { open(item); };
          var clickHandler = function (event) {
            event.preventDefault();
            open(item);
          };
          item.addEventListener('mouseenter', mouseHandler);
          trigger.addEventListener('focus', focusHandler);
          trigger.addEventListener('click', clickHandler);
          state.cleanups.push(function () {
            item.removeEventListener('mouseenter', mouseHandler);
            trigger.removeEventListener('focus', focusHandler);
            trigger.removeEventListener('click', clickHandler);
          });
        });
      })(items);

      group.dataset.revealReady = 'true';
    }
  }

  function setupMobileVideo(state) {
    var mediaNodes = state.root.querySelectorAll('[data-centauri-c07-mobile-media]');
    for (var m = 0; m < mediaNodes.length; m++) {
      var media = mediaNodes[m];
      if (media.dataset.mobileVideoReady === 'true') continue;
      var button = media.querySelector('[data-centauri-c07-mobile-play]');
      var video = media.querySelector('video');
      if (!button || !video) continue;

      (function (targetMedia, targetVideo, targetButton) {
        function play() {
          prepareVideoPlayback(targetVideo);
          revealVideoSources(targetVideo);
          setVideoBlocked(targetVideo, false);
          targetMedia.classList.add('is-mobile-video-playing');
          if (typeof targetVideo.play === 'function') {
            var promise = targetVideo.play();
            if (promise && typeof promise.catch === 'function') {
              promise.catch(function () {
                setVideoBlocked(targetVideo, true);
                targetMedia.classList.remove('is-mobile-video-playing');
              });
            }
          }
        }

        var clickHandler = function (event) {
          event.preventDefault();
          event.stopPropagation();
          play();
        };
        var pauseHandler = function () { targetMedia.classList.remove('is-mobile-video-playing'); };
        var playHandler = function () { targetMedia.classList.add('is-mobile-video-playing'); };

        targetButton.addEventListener('click', clickHandler);
        targetVideo.addEventListener('pause', pauseHandler);
        targetVideo.addEventListener('play', playHandler);
        // Native muted autoplay can fire `play` before these listeners bind,
        // leaving the play-button overlay stacked on an already-playing video.
        // Sync the initial state (idempotent with the event path).
        if (!targetVideo.paused && !targetVideo.ended) { playHandler(); }
        state.cleanups.push(function () {
          targetButton.removeEventListener('click', clickHandler);
          targetVideo.removeEventListener('pause', pauseHandler);
          targetVideo.removeEventListener('play', playHandler);
          targetMedia.classList.remove('is-mobile-video-playing');
          delete targetMedia.dataset.mobileVideoReady;
        });
      })(media, video, button);

      media.dataset.mobileVideoReady = 'true';
    }
  }

  function bindLifecycle(state) {
    var visibilityHandler = function () { scheduleMediaPlayback(state, 'visibility'); };
    document.addEventListener('visibilitychange', visibilityHandler);
    state.cleanups.push(function () {
      document.removeEventListener('visibilitychange', visibilityHandler);
    });

    var pageShowHandler = function () { scheduleMediaPlayback(state, 'pageshow'); };
    window.addEventListener('pageshow', pageShowHandler);
    state.cleanups.push(function () {
      window.removeEventListener('pageshow', pageShowHandler);
    });

    syncViewportTracking(state);
    state.cleanups.push(function () {
      if (state.scrollMediaHandler) window.removeEventListener('scroll', state.scrollMediaHandler);
      state.scrollMediaHandler = null;
      if (state.viewportObserver && state.viewportObserver.disconnect) state.viewportObserver.disconnect();
      state.viewportObserver = null;
    });

    var mobileTabbarHandler = function () { scheduleMobileTabbarPin(state); };
    window.addEventListener('scroll', mobileTabbarHandler, { passive: true });
    window.addEventListener('resize', mobileTabbarHandler, { passive: true });
    scheduleMobileTabbarPin(state);
    state.cleanups.push(function () {
      window.removeEventListener('scroll', mobileTabbarHandler);
      window.removeEventListener('resize', mobileTabbarHandler);
      if (state.mobileTabbarFrame) window.cancelAnimationFrame(state.mobileTabbarFrame);
      state.mobileTabbarFrame = 0;
      setMobileTabbarPinned(state, false);
    });

    var resizeHandler = function () {
      syncViewportTracking(state);
      syncCarouselMode(state);
      syncScrollDriveMode(state);
      window.clearTimeout(state.resizeTimer);
      state.resizeTimer = window.setTimeout(function () {
        applyDynamicTrack(state);
        ensureScrollDrive(state);
        if (!mobileMode()) updateViewportState(state);
        scheduleMediaPlayback(state, 'resize');
      }, 150);
    };
    window.addEventListener('resize', resizeHandler, { passive: true });
    state.cleanups.push(function () {
      window.removeEventListener('resize', resizeHandler);
    });
  }

  function setup(root) {
    if (!root || root.centauriC07State) return root ? root.centauriC07State : null;

    var panels = toArray(root.querySelectorAll(PANEL_SELECTOR));
    var strip = root.querySelector('[data-centauri-tabs-strip]');
    if (!strip || panels.length < 1) return null;

    var section = root.closest ? root.closest('.centauri-c07-feature-tabs') : null;
    var state = {
      root: root,
      section: section,
      scroller: root.querySelector('[data-centauri-tabs-scroll]'),
      stage: root.querySelector('[data-centauri-tabs-stage]'),
      motionShell: root.querySelector('[data-centauri-c07-motion-shell]'),
      strip: strip,
      panels: panels,
      count: panels.length,
      tabs: [],
      activeIndex: 0,
      activeInViewport: false,
      cleanups: [],
      titleCarousel: root.querySelector('[data-centauri-c07-title-carousel]'),
      mediaCarousel: root.querySelector('[data-centauri-c07-media-carousel]'),
      titleWrapper: root.querySelector('[data-centauri-c07-title-wrapper]'),
      mediaWrapper: root.querySelector('[data-centauri-c07-media-wrapper]'),
      titleSlides: [],
      mediaSlides: [],
      mediaPlacements: [],
      enableCoverflow: toBool(root.getAttribute('data-enable-coverflow'), true),
      enableScrollDrive: toBool(root.getAttribute('data-enable-scroll-drive'), true),
      carouselReady: false,
      carouselEventsBound: false,
      waitingForCarousel: false,
      syncingCarousel: false,
      titleSwiper: null,
      mediaSwiper: null,
      lastScrollProgress: null,
      scrollIndex: -1,
      motionDirection: 0,
      transitionDirection: 'forward',
      manualLock: false,
      destroyed: false,
      unlockTimer: 0,
      refreshTimer: 0,
      resizeTimer: 0,
      playbackFrame: 0,
      playbackRetryTimer: 0,
      playbackTransitionTimer: 0,
      scrollTrigger: null,
      fallbackHandler: null,
      fallbackFrame: 0,
      scrollMediaHandler: null,
      viewportObserver: null,
      vendorObserver: null,
      vendorRequested: false,
      carouselObserver: null,
      carouselRequested: false,
      carouselInteractionCleanup: null,
      mobileTabbarFrame: 0
    };

    root.centauriC07State = state;
    root.dataset.centauriTabsReady = 'true';
    root.setAttribute('data-centauri-c07-count', String(state.count));
    if (section) {
      section.setAttribute('data-centauri-tabs-ready', 'true');
      section.setAttribute('data-centauri-c07-count', String(state.count));
    }

    buildTabs(state);

    var initial = 0;
    for (var i = 0; i < panels.length; i++) {
      if (panels[i].classList.contains('is-active')) {
        initial = i;
        break;
      }
    }

    syncCarouselMode(state);

    setupReveal(state);
    setupMobileVideo(state);
    setupAssetRefresh(state);
    bindLifecycle(state);
    if (!mobileMode()) updateViewportState(state);
    applyDynamicTrack(state);
    activate(state, initial, false, true);
    ensureScrollDrive(state);
    scheduleMediaPlayback(state, 'setup');

    return state;
  }

  function teardownRoot(root) {
    var state = root && root.centauriC07State;
    if (!state) return;

    state.destroyed = true;
    window.clearTimeout(state.unlockTimer);
    window.clearTimeout(state.refreshTimer);
    window.clearTimeout(state.resizeTimer);
    window.cancelAnimationFrame(state.playbackFrame);
    window.clearTimeout(state.playbackRetryTimer);
    window.clearTimeout(state.playbackTransitionTimer);
    if (state.mobileTabbarFrame) window.cancelAnimationFrame(state.mobileTabbarFrame);
    state.mobileTabbarFrame = 0;
    setMobileTabbarPinned(state, false);
    killScrollDrive(state);
    if (state.viewportObserver && state.viewportObserver.disconnect) state.viewportObserver.disconnect();
    state.viewportObserver = null;
    if (state.scrollMediaHandler) window.removeEventListener('scroll', state.scrollMediaHandler);
    state.scrollMediaHandler = null;
    if (state.vendorObserver && state.vendorObserver.disconnect) state.vendorObserver.disconnect();
    state.vendorObserver = null;
    if (state.carouselObserver && state.carouselObserver.disconnect) state.carouselObserver.disconnect();
    state.carouselObserver = null;
    if (state.carouselInteractionCleanup) state.carouselInteractionCleanup();
    state.carouselInteractionCleanup = null;
    restoreCarouselDom(state);

    while (state.cleanups.length) {
      var cleanup = state.cleanups.pop();
      try { cleanup(); } catch (e) {}
    }

    pauseVideos(root);
    if (state.strip) {
      state.strip.innerHTML = '';
      state.strip.hidden = false;
      state.strip.style.removeProperty('--c07-tab-count');
    }

    if (state.motionShell) {
      state.motionShell.style.removeProperty('--c07-scroll-progress');
      state.motionShell.style.removeProperty('--c07-local-progress');
      state.motionShell.style.removeProperty('--c07-motion-direction');
      state.motionShell.style.removeProperty('--c07-shell-shift');
      state.motionShell.classList.remove('is-motion-forward', 'is-motion-backward');
      state.motionShell.removeAttribute('data-centauri-active-index');
      state.motionShell.removeAttribute('data-c07-direction');
    }

    for (var p = 0; p < state.panels.length; p++) {
      state.panels[p].removeAttribute('hidden');
      state.panels[p].classList.remove('is-active');
    }

    root.classList.remove('is-coverflow-enhanced', 'is-coverflow-pending', 'is-coverflow-ready', 'is-coverflow-fallback', 'is-simple-tabs', 'is-scroll-drive-ready', 'is-scroll-drive-fallback', 'is-scroll-drive-disabled');
    root.removeAttribute('data-centauri-active-index');
    root.removeAttribute('data-centauri-c07-count');
    root.removeAttribute('data-centauri-carousel-ready');
    root.removeAttribute('data-centauri-scroll-ready');
    root.removeAttribute('data-centauri-scroll-progress');
    root.removeAttribute('data-c07-direction');
    delete root.dataset.centauriTabsReady;
    root.centauriC07State = null;

    if (state.section) {
      state.section.classList.remove('is-coverflow-enhanced', 'is-coverflow-pending', 'is-coverflow-ready', 'is-coverflow-fallback', 'is-simple-tabs', 'is-scroll-drive-disabled');
      state.section.removeAttribute('data-centauri-tabs-ready');
      state.section.removeAttribute('data-centauri-active-index');
      state.section.removeAttribute('data-centauri-c07-count');
      state.section.removeAttribute('data-c07-direction');
    }
  }

  function init(scope) {
    var roots = findRootNodes(scope || document);
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  function findPanelByBlockEvent(event) {
    var detail = event && event.detail;
    var blockId = detail && detail.blockId;
    var panels;
    var i;

    if (blockId) {
      panels = document.querySelectorAll('[data-centauri-tab-block-id]');
      for (i = 0; i < panels.length; i++) {
        if (panels[i].getAttribute('data-centauri-tab-block-id') === blockId) return panels[i];
      }
    }

    var target = event && event.target;
    if (matches(target, PANEL_SELECTOR)) return target;
    return target && target.querySelector ? target.querySelector(PANEL_SELECTOR) : null;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var roots = findRootNodes(event.target || document);
    for (var i = 0; i < roots.length; i++) teardownRoot(roots[i]);
  });

  document.addEventListener('shopify:section:select', function (event) {
    init(event.target || document);
  });

  document.addEventListener('shopify:block:select', function (event) {
    init(document);
    var panel = findPanelByBlockEvent(event);
    if (!panel) return;
    var root = panel.closest ? panel.closest(ROOT_SELECTOR) : null;
    var state = setup(root);
    if (!state) return;
    var index = state.panels.indexOf(panel);
    if (index >= 0) goTo(state, index, true);
  });

  window.CentauriC07FeatureTabs = {
    version: VERSION,
    init: init,
    teardown: teardownRoot
  };
})();
